import React from 'react';
import themes from 'styles/themes';
import logo from '../../../assets/img/logo_black.png';
function AppVersion(props) {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '70vh',
                padding: '8px 24px',
            }}
        >
            <div
                style={{
                    width: 250,
                    textAlign: 'center',
                }}
            >
                <img
                    src={logo}
                    alt="logo"
                    width={100}
                    style={{
                        marginBottom: 30,
                    }}
                />
                <p
                    style={{
                        fontSize: 14,
                        fontWeight: 400,
                        color: themes.palette.primary.main,
                        fontFamily: 'PoppinsRegular',
                        marginBottom: 10,
                    }}
                >
                    Version {process.env.REACT_APP_WEBAPP_VERSION || 'development'}
                </p>
                <p
                    style={{
                        fontSize: 14,
                        fontWeight: 400,
                        color: themes.palette.primary.main,
                        fontFamily: 'PoppinsRegular',
                        marginBottom: 10,
                    }}
                >
                    Copyright ⓒ‎ 2021-2025 Taffi Inc.
                </p>
                <p
                    style={{
                        fontSize: 14,
                        fontWeight: 400,
                        color: themes.palette.primary.main,
                        fontFamily: 'PoppinsRegular',
                        marginBottom: 10,
                    }}
                >
                    All rights reserved.
                </p>
            </div>
        </div>
    );
}

export default AppVersion;
